import React from 'react';
import { Alert, Collapse } from '@mui/material';

interface Props {
  message: string | null;
  onDismiss?: () => void;
}

export const ErrorAlert: React.FC<Props> = ({ message, onDismiss }) => {
  return (
    <Collapse in={!!message}>
      <Alert
        severity="error"
        onClose={onDismiss}
        sx={{ my: 2 }}
      >
        {message}
      </Alert>
    </Collapse>
  );
};
